"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var toPath_1 = tslib_1.__importDefault(require("lodash/toPath"));
var react_1 = tslib_1.__importStar(require("react"));
var FormikSubscription = /** @class */ (function () {
    function FormikSubscription() {
        this.resetCallbacks = {};
    }
    FormikSubscription.prototype.subscribeToReset = function (name, onReset) {
        this.resetCallbacks[name] = onReset;
    };
    FormikSubscription.prototype.onReset = function (values) {
        Object.values(this.resetCallbacks).forEach(function (callback) { return callback(values); });
    };
    return FormikSubscription;
}());
exports.FormikSubscription = FormikSubscription;
/**
 * Deeply get a value from an object via its path.
 */
function getIn(obj, key, def, p) {
    if (p === void 0) { p = 0; }
    var path = toPath_1.default(key);
    while (obj && p < path.length) {
        obj = obj[path[p++]];
    }
    return obj === undefined ? def : obj;
}
exports.getIn = getIn;
/**
 * Converts fields expected by Formik to those used by the ASG components
 * @param Component The component to wrap
 */
exports.withFormFields = function (Component, valueProp, valueChangeProp) {
    // ...and returns another component...
    return function (props) {
        var _a = valueChangeProp
            ? react_1.useState(props.initialInternalValue)
            : [undefined, undefined], internalValue = _a[0], setInternalValue = _a[1];
        var field = props.field, form = props.form, convertValue = props.convertValue, onChange = props.onChange, onBlur = props.onBlur, disabled = props.disabled, formikSubscription = props.formikSubscription, initialInternalValue = props.initialInternalValue, rest = tslib_1.__rest(props, ["field", "form", "convertValue", "onChange", "onBlur", "disabled", "formikSubscription", "initialInternalValue"]);
        var error = getIn(form.errors, field.name);
        var touch = getIn(form.touched, field.name);
        var customOnChange = null;
        if (valueChangeProp) {
            customOnChange = rest[valueChangeProp];
            delete rest[valueChangeProp];
        }
        var fieldOnChange = field.onChange, fieldOnBlur = field.onBlur, fieldProps = tslib_1.__rest(field, ["onChange", "onBlur"]);
        var componentProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, fieldProps), rest), { touch: touch, error: touch && error ? true : false, errorMessage: touch ? error : undefined, disabled: form.isSubmitting || disabled });
        if (convertValue) {
            componentProps.value = convertValue(componentProps.value);
        }
        if (formikSubscription && setInternalValue) {
            formikSubscription.subscribeToReset(field.name, function (values) {
                setInternalValue(undefined);
            });
        }
        if (valueProp) {
            componentProps[valueProp] = componentProps.value;
            componentProps.value = internalValue;
        }
        if (valueChangeProp) {
            componentProps[valueChangeProp] = customOnChange
                ? function (e) {
                    customOnChange(e);
                    fieldOnChange(e);
                }
                : fieldOnChange;
        }
        var onValueChange = !setInternalValue
            ? fieldOnChange
            : function (e) { return setInternalValue((e.target || e.currentTarget).value); };
        componentProps.onChange = onChange
            ? function (e) {
                onChange(e);
                onValueChange(e);
            }
            : onValueChange;
        componentProps.onBlur = onBlur
            ? function (e) {
                onBlur(e);
                fieldOnBlur(e);
            }
            : fieldOnBlur;
        return react_1.default.createElement(Component, tslib_1.__assign({}, componentProps));
    };
};
//# sourceMappingURL=withFormFields.hoc.js.map